/**
 * **Tema Ant Design konsol** — warnanya diambil dari sistem yang sama dengan layar kasir.
 *
 * ### ⭐ Kenapa AntD di sini, dan TIDAK di `pos-web`
 * Konsol ini CRUD: tabel, formulir, date picker, pohon, modal — persis yang AntD sudah selesaikan,
 * dan bentuk yang sama dengan konsol OSB Nexus yang sudah dipakai sehari-hari.
 * ⛔ Layar kasir beda urusan: ia diukur dalam **ketukan & milidetik**, tata letaknya khas (kisi
 * menu, struk, keypad), dan jalan di tablet murah yang kadang luring. Pustaka komponen desktop di
 * sana adalah beban yang dibayar tiap transaksi.
 *
 * ⚠️ Token warnanya **disalin dari `styles.css`**, bukan dikarang ulang. Pemilik membuka konsol dan
 * layar kasir di hari yang sama; dua hijau yang berbeda tipis membuat orang bertanya mana yang benar.
 */
import type { ThemeConfig } from 'antd';

/** Enamel hijau-tua — sama dengan `--enamel` di sistem "Papan & Buku". */
export const ENAMEL = '#0c3b35';

export const lightTheme: ThemeConfig = {
  token: {
    colorPrimary: ENAMEL,
    colorLink: ENAMEL,
    colorSuccess: '#0f7b4f',
    colorWarning: '#b54708',
    colorError: '#b42318',
    borderRadius: 10,
    fontSize: 14,
  },
  components: {
    Layout: { siderBg: ENAMEL, triggerBg: '#14564d' },
    Menu: { darkItemBg: ENAMEL, darkSubMenuItemBg: ENAMEL, darkItemSelectedBg: '#14564d' },
  },
};
